module.exports = __webpack_public_path__ + "static/media/padroes_sevicos_iteroperabilidade.7f7107f3.png";